import Model from "./Model";

export default class ZohoAccount extends Model {

    static getByCompanyId = async (company_id) => {
        const variables = { company_id: company_id };
        const res = await this.runQuery(GetZohoAccountsByCompany, variables);
        return res.data.zohoAccountsByCompany;
    }
}

const GetZohoAccountsByCompany = `
query GetZohoAccountsByCompany($company_id: Int!) {
    zohoAccountsByCompany(company_id: $company_id) {
        id
        name
        dst_domain
        sync_date
        last_updated
    }
}`;
